
import React from 'react';
import { Button } from '../../../components/base/Button';

export const HeroSection: React.FC = () => {
  return (
    <section 
      id="home" 
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      style={{
        background: 'linear-gradient(135deg, #1e3a8a 0%, #7c3aed 50%, #4c1d95 100%)'
      }}
    >
      <div 
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Cpath d='M30 30c0-11.046 8.954-20 20-20s20 8.954 20 20-8.954 20-20 20-20-8.954-20-20zm0-30c0-11.046 8.954-20 20-20s20 8.954 20 20-8.954 20-20 20-20-8.954-20-20z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30" />
      
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 flex items-center min-h-screen">
        <div className="w-full grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div>
              <h2 className="text-7xl lg:text-8xl font-bold text-white leading-tight">
                Secure Your
              </h2>
              <h2 className="text-7xl lg:text-8xl font-bold text-white leading-tight">
                Digital Life
              </h2>
            </div>
            
            <p className="text-xl text-white/80 max-w-lg leading-relaxed">
              Protect your privacy and secure your online activities with our military-grade VPN technology. Fast, reliable, and completely private.
            </p>
            
            <div className="flex items-center space-x-4">
              <Button size="lg" className="group">
                Download Now
                <div className="ml-3 w-6 h-6 bg-white/20 rounded-full flex items-center justify-center group-hover:bg-white/30 transition-colors">
                  <i className="ri-arrow-right-line text-white text-sm"></i>
                </div>
              </Button>
            </div>
          </div>
          
          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/17fd4013cdf8c66855d8e91f8d41f686.jpg"
              alt="VPN Security Dashboard"
              className="w-full h-auto rounded-2xl shadow-2xl object-cover"
            />
          </div>
        </div>
      </div>
      
      <div className="absolute bottom-16 left-1/2 transform -translate-x-1/2 text-center">
        <h3 className="text-8xl lg:text-9xl font-bold text-white opacity-20 tracking-wider">
          PRIVACY FIRST
        </h3>
      </div>
    </section>
  );
};
